import { VUE } from '@/features/core/container';
import registerComponents from '@/util/component-loader';
import { configure } from '@/util/container';

export default configure(async (get) => {
  const vue = await get(VUE);

  registerComponents(vue, require.context('..', true, /\.global\.vue$/), 'app-support-');
});
